module.exports = __webpack_public_path__ + "static/media/undo.8b0c0109.svg";